import React from "react";
import styles from "./AnimationLoader.module.scss";

export interface LoaderProps {
  height?: "40" | "48";
}

class AnimationLoader extends React.Component<LoaderProps> {
  render() {

    let style = styles.LdsSpinner;
    if (this.props.height === "48") {
      style = styles.LdsSpinnerII;
    }

    return (
      <div className={styles.Lds}>
        <div className={style}>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
        </div>

      </div>
    );
  }
}

export default AnimationLoader;
